import Spinner from '.';

const SpinnerFullScreen = () => (
  <div className='flex h-full items-center justify-center'>
    <Spinner />
  </div>
);

export default SpinnerFullScreen;
